/* Keep existing carts and checkout metadata aligned with the shared delivery promise. */
(() => {
  const config = window.HonnarasDelivery;
  if (!config) return;
  const root = config.root.replace(/\/$/, '');
  let pending;
  async function request(path, body) {
    const response = await fetch(root + path, body ? {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    } : { cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to update delivery details. Please try again.');
    return response.json();
  }
  async function refreshDate() {
    const response = await fetch(root + '/?section_id=delivery-date&_delivery=' + Date.now(), { cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to update delivery details. Please try again.');
    const html = await response.text();
    const match = html.match(/<span\b[^>]*data-honnaras-delivery-value[^>]*>([^<]+)<\/span>/);
    const date = match?.[1]?.trim();
    if (!date || !/^\d{1,2}(st|nd|rd|th) [A-Za-z]+ \d{4}$/.test(date)) {
      throw new Error('Unable to update delivery details. Please try again.');
    }
    config.date = date;
    document.querySelectorAll('[data-honnaras-delivery-date]').forEach(element => { element.textContent = date; });
    document.querySelectorAll('[name="properties[Expected delivery]"]').forEach(input => { input.value = date; });
  }
  async function synchronize() {
    await refreshDate();
    let cart = await request('/cart.js');
    let changed = false;
    // Re-read the returned cart after each change: changing properties changes line keys
    // and may merge otherwise identical lines. Preserve every other customer property.
    const limit = cart.items.length + 1;
    for (let i = 0; i < limit; i++) {
      const item = cart.items.find(item => item.properties?.['Expected delivery'] !== config.date);
      if (!item) break;
      cart = await request('/cart/change.js', {
        id: item.key, quantity: item.quantity,
        properties: { ...item.properties, 'Expected delivery': config.date }
      });
      changed = true;
    }
    if (cart.items.some(item => item.properties?.['Expected delivery'] !== config.date)) {
      throw new Error('Your cart changed. Please try checkout again.');
    }
    if (cart.items.length && cart.attributes?.['Expected delivery'] !== config.date) {
      cart = await request('/cart/update.js', {
        attributes: { ...cart.attributes, 'Expected delivery': config.date }
      });
      changed = true;
    }
    if (changed) document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true, detail: { resource: cart, sourceId: 'delivery-sync', data: { source: 'delivery-sync' } }
    }));
    return cart;
  }
  window.honnarasSyncDelivery = () => {
    if (!pending) {
      document.documentElement.classList.add('delivery-sync-pending');
      document.querySelectorAll('.additional-checkout-buttons').forEach(buttons => { buttons.inert = true; });
      let succeeded = false;
      pending = synchronize().then(cart => { succeeded = true; return cart; }).finally(() => {
        pending = null;
        if (succeeded) {
          document.documentElement.classList.remove('delivery-sync-pending');
          document.querySelectorAll('.additional-checkout-buttons').forEach(buttons => { buttons.inert = false; });
        }
      });
    }
    return pending;
  };
  const quietly = () => window.honnarasSyncDelivery().catch(error => console.warn(error.message));
  document.addEventListener('DOMContentLoaded', quietly);
  window.addEventListener('pageshow', event => { if (event.persisted) quietly(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) quietly(); });
  document.addEventListener('cart:update', event => {
    if (event.detail?.sourceId !== 'delivery-sync') {
      // If another update arrives during synchronization, check once more afterwards.
      const previous = pending;
      if (previous) previous.then(quietly, quietly); else quietly();
    }
  });
  async function checkout(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = event.target.closest?.('[name="checkout"], a[href*="/checkout"]');
    if (button) button.setAttribute('aria-busy', 'true');
    try {
      await window.honnarasSyncDelivery();
      window.location.href = root + '/checkout';
    } catch (error) {
      window.alert(error.message);
    } finally {
      if (button) button.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', event => {
    const target = event.target.closest?.('[name="checkout"], a[href*="/checkout"]');
    if (target && !target.disabled) checkout(event);
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.id === 'cart-form' && (!event.submitter || event.submitter.name === 'checkout')) checkout(event);
  }, true);
})();
